import { createRandomString } from "@/general_functions";
import { storage } from ".";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";

const defaultStorageLocation = "uploads/media/";
export async function uploadFile(file: File): Promise<{
  id: string;
  extension: string;
  url: string;
  size: number;
  storagePath: string;
  mimeType: string;
}> {
  // Create unique identifer
  const id = createRandomString(50);

  // Get the file extension
  const extension = file.name.split(".").pop() ?? "";

  // Create a storage reference
  const storageRef = ref(
    storage,
    defaultStorageLocation + id + "." + extension,
  );

  // 'file' comes from the Blob or File API
  const snapshot = await uploadBytes(storageRef, file);

  // Get the download URL
  const url = await getDownloadURL(storageRef);

  // Get the storage path
  const storagePath = snapshot.ref.fullPath;
  const mimeType = file.type;
  const size = file.size;

  return { id, size, extension, url, storagePath, mimeType };
}
